import { render, staticRenderFns } from "./SpinnerWheelResult.vue?vue&type=template&id=e6420084&scoped=true&"
import script from "./SpinnerWheelResult.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelResult.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelResult.vue?vue&type=style&index=0&id=e6420084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6420084",
  null
  
)

export default component.exports